import { Ref, forwardRef } from "react";
import ReactQuill from "react-quill";
import EditorFunction from "./EditorFunction";
import TextEditor from "./TextEditor";


export default forwardRef<ReactQuill, { initialValue: string, onChange: any, reference: any }>(
  (props, ref) => <TextEditor {...props} ref={ref} />
);
